import {
  AdresseType,
  Pays,
  TypeVoie,
} from '../../common/entreprise/adresse.definition';
import { EtatEntiteHubspot } from '../../common/hubspot/hubspot.definition';
import { AvancementSociete } from '../../conformite/avancement/controller/avancement.definition';
import { ContactCivilite } from '../../contact/controller/contact.definition';
import {
  ActiviteBancaire,
  Categorie,
  CategorieRepresentation,
  OrganisationProfessionnelle,
} from '../../info-societe-orias/service/info-societe-orias.definition';
import {
  AAtteintLeTarif as AAtteintLeTarifService,
  EntrepriseStatus,
  FormeJuridique as FormeJuridiqueService,
  TrancheEffectif as TrancheEffectifService,
  TypeAdhesionActive as TypeAdhesionActiveService,
  TypeAdhesionInactive as TypeAdhesionInactiveService,
  TypeAdhesion as TypeAdhesionService,
  TypeSouscripteur as TypeSouscripteurService,
} from '../service/entreprise.definition';
export const entrepriseControllerUrl = 'entreprise';

export type EntrepriseStatusResponse = EntrepriseStatus;
export const EntrepriseStatusResponse = EntrepriseStatus;

export const TypeAdhesion = TypeAdhesionService;
export type TypeAdhesion = TypeAdhesionService;

export const TypeAdhesionInactive = TypeAdhesionInactiveService;
export type TypeAdhesionInactive = TypeAdhesionInactiveService;

export const TypeAdhesionActive = TypeAdhesionActiveService;
export type TypeAdhesionActive = TypeAdhesionActiveService;

export const TrancheEffectif = TrancheEffectifService;
export type TrancheEffectif = TrancheEffectifService;
export const FormeJuridique = FormeJuridiqueService;
export type FormeJuridique = FormeJuridiqueService;
export const TypeSouscripteur = TypeSouscripteurService;
export type TypeSouscripteur = TypeSouscripteurService;

export const AAtteintLeTarif = AAtteintLeTarifService;
export type AAtteintLeTarif = AAtteintLeTarifService;

export type EntrepriseAControllerResponseType = {
  hubspotId: string;
  siren: string;
  raisonSociale: string;
  numeroOrias?: string;
  adresse: AdresseType;
  formeJuridique: FormeJuridique;
  trancheEffectif: TrancheEffectif;
  chiffreAffaire: number;
  categoriesActivites: Categorie[];
  categoriesActivitesAccessoires: Categorie[];
  categorieRepresentation: CategorieRepresentation;
  organisationProfessionnelle: OrganisationProfessionnelle[];
  sousCategorieCOBSP: ActiviteBancaire[];
  sousCategoriesIOBSP: ActiviteBancaire[];
  millesime: number;
  avancement: AvancementSociete;
  declarationActiviteIASOptionnelle: boolean;
  declarationActiviteIOBSPOptionnelle: boolean;
  conformiteOptionnelle?: boolean;
  consentementEDI: boolean;
  renouvellementOffert?: boolean;
  dateCreationEntreprise?: string;
  idContactPrincipal?: string;
  idEntreprisePrincipal?: string;
} & ContactMediationType;

export type EntreprisePrincipaleResponseType = {
  hubspotId: string;
  siren: string;
  raisonSociale: string;
  adresse: AdresseType;
  formeJuridique: FormeJuridique;
  typeAdhesion: TypeAdhesion;
  typeSouscripteur: TypeSouscripteur;
  trancheEffectif: TrancheEffectif;
  millesimeActuel: number;
};

export type AdresseRequestType = {
  typeVoie: TypeVoie;
  libelleVoie: string;
  numeroVoie: string;
  complementAdresse?: string;
  codePostal: string;
  ville: string;
  pays: Pays;
};

export type UpdateEntrepriseAControllerRequestType = {
  hubspotId: string;
  raisonSociale: string;
  numeroOrias?: string;
  adresse: AdresseType;
  formeJuridique: FormeJuridique;
  trancheEffectif: TrancheEffectif;
  chiffreAffaire: number;
  categorieRepresentation: CategorieRepresentation;
  organisationProfessionnelle: OrganisationProfessionnelle[];
  sousCategorieCOBSP: ActiviteBancaire[];
  sousCategoriesIOBSP: ActiviteBancaire[];
  consentementEDI?: boolean;
} & ContactMediationType;

export type UpdateEntreprisePrincipaleRequestType = {
  raisonSociale: string;
  formeJuridique: FormeJuridique;
  trancheEffectif: TrancheEffectif;
  typeSouscripteur: TypeSouscripteur;
  adresse: AdresseType;
};

export type DeleteEntrepriseRequestType = {
  ids: string[];
};

export type SetHasReachedLimitRequestType = {
  hasReachedLimit: AAtteintLeTarif;
};

export type EtatEntreprise = EtatEntiteHubspot;
export const EtatEntreprise = EtatEntiteHubspot;

export const setIsDoubleAuthEnabledUrl = '/entreprise/isDoubleAuthEnabled';
export interface SetIsDoubleAuthEnabledType {
  isDoubleAuthEnabled: boolean;
}

export type ContactMediationType = {
  nomMediation: string;
  prenomMediation: string;
  civiliteMediation: ContactCivilite;
  telephoneMediation?: string;
  mailMediation: string;
};
